import React from 'react'
import styled from 'styled-components'
import Image from '../../components/Image'
import { useAsset, useTranslation, useUrl } from '../../store/hooks/dataHooks'

const BenefitsList = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0 0;
`

const ExpertModePreview: React.FC = () => {
  const headerImage = useAsset('expert.preview-header')
  const t = useTranslation()
  const newsletterUrl = useUrl('newsletter')

  return (
    <>
      <Image image={headerImage} responsive />
      <div className="section no-border--all">
        <div className="container">
          <h2 className="text-center">{t('ui.expert-teaser.headline')}</h2>
          <h3 className="text-center">{t('ui.expert-teaser.subline')}</h3>
          <BenefitsList>
            <ul className="list list--check">
              <li>{t('ui.expert-teaser.bullet1')}</li>
              <li>{t('ui.expert-teaser.bullet2')}</li>
              <li>{t('ui.expert-teaser.bullet3')}</li>
            </ul>
          </BenefitsList>
          <div className="text-center">
            <a href={newsletterUrl} target="_blank" rel="noreferrer" className="button button--solid button--cta">
              {t('ui.request-newsletter')}
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default ExpertModePreview
